import axios from '../utils/axios';

export default function postCompetitionScore(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/v2/competition/admin/score', data)
    )
}
